// extracted by mini-css-extract-plugin
export var noMargin = "p_qr d_b8";
export var carouselCol = "p_qs d_cz";
export var carouselWrapper = "p_k9 d_k9 d_bw d_bz d_bL d_s d_D";
export var carouselImageWrapper = "p_lb d_lb d_D d_s";
export var carouselContainer = "p_qt d_cz";
export var carouselContainerFull = "p_qv d_dQ";
export var carouselImg = "p_mR d_lc d_s d_D d_bN";
export var imageTextWrapperLeft = "p_k4 d_k4 d_k3 d_X d_bQ";
export var imageTextWrapperCenter = "p_k5 d_k5 d_k3 d_X d_bQ";
export var imageTextWrapperRight = "p_k6 d_k6 d_k3 d_X d_bQ";
export var imageTextWrapperHidden = "p_k2 d_k2";
export var imageAltSmall = "p_qw d_k7";
export var imageAltNormal = "p_qx d_k7";
export var imageAltLarge = "p_qy d_k7";
export var imageTextSmall = "p_qz d_k8";
export var imageTextNormal = "p_qB d_k8";
export var imageTextLarge = "p_qC d_k8";